import { render } from "./StaffVehiclesDashboard.vue?vue&type=template&id=1571a6f5"
import script from "./StaffVehiclesDashboard.vue?vue&type=script&lang=js"
export * from "./StaffVehiclesDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__